import React from "react";
import { Badge, Paper, Text } from "@mantine/core";
import { skipToken } from "@reduxjs/toolkit/query";
import { DeckBimViewer } from "@multiconsult-group/multiplacer-ui";
import { useGetMcbimItemsInSpaceQuery } from "../../../../openapi";
import { useAppSelector } from "../../../app/hooks";
import { selectSelectedSimilarRoomWithIfcDesign } from "./similarRoomsWithIfcDesignSelectors";
import {
  selectSimilarRoomWithIfcDesignViewerCeilingGridPixPaths,
  selectSimilarRoomWithIfcDesignViewerMcbimItemsArgs,
  selectSimilarRoomWithIfcDesignViewerPixPolygons,
  selectSimilarRoomWithIfcDesignViewerZoomExtentKey,
} from "./similarRoomsWithIfcDesignViewerSelectors";

export const SimilarRoomWithIfcDesignViewer: React.FC = () => {
  const room = useAppSelector(selectSelectedSimilarRoomWithIfcDesign);
  const rotation = useAppSelector((state) => state.design.rotation);
  const mcbimItemsArgs = useAppSelector(selectSimilarRoomWithIfcDesignViewerMcbimItemsArgs);

  const { isFetching } = useGetMcbimItemsInSpaceQuery(mcbimItemsArgs ?? skipToken);

  const polygons = useAppSelector(selectSimilarRoomWithIfcDesignViewerPixPolygons);
  const ceilingGridPaths = useAppSelector(selectSimilarRoomWithIfcDesignViewerCeilingGridPixPaths);
  const zoomExtentKey = useAppSelector(selectSimilarRoomWithIfcDesignViewerZoomExtentKey);

  if (!room) {
    return (
      <Paper
        bg="gray.0"
        radius="sm"
        p="md"
        h="100%"
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Text size="sm" c="dimmed">
          Velg et rom for å vise IFC-design
        </Text>
      </Paper>
    );
  }

  return (
    <Paper bg="gray.0" radius="sm" p="sm" h="100%" style={{ minHeight: 0, position: "relative" }}>
      {isFetching && (
        <Badge
          variant="white"
          color="gray"
          style={{ position: "absolute", top: 12, right: 12, zIndex: 2 }}
        >
          Laster IFC
        </Badge>
      )}
      <DeckBimViewer
        flip2dCoordinate={true}
        angle={rotation}
        paths={ceilingGridPaths}
        polygons={polygons}
        zoomExtentKey={zoomExtentKey}
      />
    </Paper>
  );
};
